import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { FlexBox } from '../box';
import { Divider } from '../divider';
import { styled } from '../styled';
import { withVersion } from '../utils';
import { ChatBubble } from './chat-bubble';
import { ChatFeedback } from './chat-feedback';
import { ChatThread, DateSeparator } from './chat-thread';
import { InboxDetailHeader } from './inbox-detail-header';
import { InboxListItem } from './inbox-list-item';
import { InboxPanelHeader } from './inbox-panel-header';
export * from './chat-bubble';
export * from './chat-feedback';
export * from './chat-thread';
export * from './inbox-detail-header';
export * from './inbox-list-item';
export * from './inbox-panel-header';
const Root = styled(FlexBox)(({ theme }) => ({
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius
}));
const ListPanel = styled(FlexBox)({
    flex: '0 0 35%',
    maxWidth: '35%',
    overflow: 'hidden'
});
const DetailPanel = styled(FlexBox)({
    flex: '1 1 65%',
    minWidth: 0,
    overflow: 'hidden'
});
const ScrollableContent = styled(FlexBox)({
    overflow: 'auto',
    minHeight: 0,
    flex: 1
});
const CenteredContent = ({ children }) => (_jsx(FlexBox, { stretch: true, hAlign: "center", vAlign: "center", children: children }));
function renderDetailContent(detailErrorState, chat, detailEmptyState) {
    if (detailErrorState) {
        return _jsx(CenteredContent, { children: detailErrorState });
    }
    if (chat) {
        return chat;
    }
    if (detailEmptyState) {
        return _jsx(CenteredContent, { children: detailEmptyState });
    }
    return null;
}
const InboxImpl = (props) => {
    const { list, chat, listHeader, detailHeader, emptyState, detailEmptyState, detailErrorState, className, ...rest } = props;
    return (_jsxs(Root, { className: className, "data-role": rest['data-role'] ?? 'inbox-layout', "data-role-value": rest['data-role-value'], children: [_jsxs(ListPanel, { stack: true, children: [listHeader, _jsx(ScrollableContent, { stack: true, stretch: true, children: list ? (_jsx(FlexBox, { stack: true, children: list })) : (emptyState && (_jsx(FlexBox, { stretch: true, hAlign: "center", vAlign: "center", children: emptyState }))) })] }), _jsx(Divider, { orientation: "vertical", flexItem: true }), _jsxs(DetailPanel, { stack: true, children: [!detailErrorState && chat ? detailHeader : null, _jsx(ScrollableContent, { stack: true, stretch: true, children: renderDetailContent(detailErrorState, chat, detailEmptyState) })] })] }));
};
InboxImpl.Header = InboxPanelHeader;
InboxImpl.DetailHeader = InboxDetailHeader;
InboxImpl.ListItem = InboxListItem;
InboxImpl.ChatBubble = ChatBubble;
InboxImpl.ChatThread = ChatThread;
InboxImpl.ChatFeedback = ChatFeedback;
InboxImpl.DateSeparator = DateSeparator;
export const Inbox = withVersion(InboxImpl, '1.0.0');
